import { QueryHookOptions } from '@apollo/client';
import { useApiLazyQuery, useApiMutation, useApiQuery } from '@common/hooks';

import {
  createTaxationPlanSpecific,
  getLines,
  getTaxationDetails,
  getTaxationDetailsInfo,
  getTaxationPlanSpecific,
  searchTaxationPlanSpecific,
  searchTaxations
} from './services';
import {
  GetTaxationDetailsResponse,
  GetTaxationDetailsVars,
  SearchTaxationPlanSpecificResponse,
  SearchTaxationPlanSpecificVars,
} from './types';

const useGetTaxations = (options?: QueryHookOptions<any, any>) =>
  useApiQuery<any, any>(
    searchTaxations,
    'searchTaxations',
    {
      ...options,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true
    },
    { withLoader: false }
  );

const useGetTaxationFilters = (options?: QueryHookOptions<any, any>) =>
  useApiQuery<any, any>(getLines, 'getLines', {
    ...options,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });

const useGetTaxationDetailsInfo = (options?: QueryHookOptions<any, any>) =>
  useApiLazyQuery<any, any>(
    getTaxationDetailsInfo,
    'getTaxationDetailsInfo',
    {
      ...options,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true
    },
    { withLoader: false }
  );

const useGetTaxationPlanSpecific = (options?: QueryHookOptions<any, any>) =>
  useApiLazyQuery<any, any>(
    getTaxationPlanSpecific,
    'getTaxationPlanSpecific',
    {
      ...options,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true
    }
  );

const useGetTaxationDetails = (
  options?: QueryHookOptions<GetTaxationDetailsResponse, GetTaxationDetailsVars>
) =>
  useApiQuery<GetTaxationDetailsResponse, GetTaxationDetailsVars>(
    getTaxationDetails,
    'getTaxationDetails',
    {
      ...options,
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true
    },
    { withLoader: false }
  );

const useSearchTaxationPlanSpecific = () =>
  useApiLazyQuery<
    SearchTaxationPlanSpecificResponse,
    SearchTaxationPlanSpecificVars
  >(searchTaxationPlanSpecific, 'searchTaxationPlanSpecific', {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true
  });

const useSearchTaxationPlanSpecificLazy = (
  options?: QueryHookOptions<
    SearchTaxationPlanSpecificResponse,
    SearchTaxationPlanSpecificVars
  >
) =>
  useApiLazyQuery<
    SearchTaxationPlanSpecificResponse,
    SearchTaxationPlanSpecificVars
  >(searchTaxationPlanSpecific, 'searchTaxationPlanSpecific', {
    ...options,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });

const useCreateTaxationPlanSpecific = () =>
  useApiMutation<any, any>(
    createTaxationPlanSpecific,
    'createTaxationPlanSpecific',
    {
      withLoader: true,
      successMsg: 'Plan Specific Taxation was added successfully'
    },
    { fetchPolicy: 'no-cache', notifyOnNetworkStatusChange: true }
  );

export {
  useGetTaxationDetailsInfo,
  useGetTaxationFilters,
  useGetTaxationPlanSpecific,
  useGetTaxations,
  useGetTaxationDetails,
  useSearchTaxationPlanSpecific,
  useSearchTaxationPlanSpecificLazy,
  useCreateTaxationPlanSpecific
};
